export const membersSummaryPageMessages = {
  MEMBERS_PAGE: {
    TITLE: 'Member Summary',
    TITLE2: 'Summary For ',
    TITLE3: 'Non-Compliant to measure ',
    SUBTITLE: {
      PART1: 'Showing member summary of the selected member group from ',
      PART2: ' to ',
    },
    SUBTITLE2:
      'Trigger conditions that are used by insurance providers as key indicators of potential catastrophic cases',
    CHART_SUBTITLE:
      'Shows the distribution of cost and claim volume for the cohort described above',
    MEMBER_SUMMARY_CARDS: {
      MEMBERS: 'Cohort Members',
      TOTAL_COST: 'Cohort Cost',
      PMPM: 'Cohort PMPM',
      PEPM: 'Cohort PEPM',
      PC_DISTRIBUTION_MEMBER: 'Primary Care Attribution',
      PC_DISTRIBUTION_COST: 'Primary Care - Cost',
      AVG_AGE: 'Average Age',
      GENDER_TITLE: 'Gender',
      NON_COMPLAINT: 'Non-Compliant',
      ELIGIBLE_POPULATION: 'Eligible Population',
      TOTAL_POPULATION: 'Total Population',
      MEMBER_DETAILS: {
        TITLE: 'Member Details',
        SUB_TITLE: 'To see more about the member details click on a member',
        SORTFIELD: 'cost',
        SORTORDER: -1,
      },
      TOP_DIAGNOSIS: {
        TITLE: 'Top',
        SUB_TITLE: 'Showing the top ',
        DROPDOWN_OPTIONS: ['Diagnosis by Cost', 'Diagnosis by Member'],
      },
      TOP_MEDICATIONS: {
        TITLE: 'Top',
        SUB_TITLE: 'Showing the top ',
        DROPDOWN_OPTIONS: ['Medications by Cost', 'Medications by Member'],
      },
      TOP_PROCEDURES: {
        TITLE: 'Top',
        SUB_TITLE: 'Showing the top ',
        DROPDOWN_OPTIONS: ['Procedures by Cost', 'Procedures by Member'],
      },
      TOP_PROVIDERS: {
        TITLE: 'Top',
        SUB_TITLE: 'Showing the top ',
        DROPDOWN_OPTIONS: ['Providers by Cost', 'Providers by Member'],
      },
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
    TOP_MEDICATIONS: {
      TITLE: 'Top Medications',
      SUB_TITLE: 'Showing top medications by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    MEMBER_DISTRIBUTION: {
      TITLE1: 'Member Distribution - Gender',
      TITLE2: 'Member Distribution - Disease Acuity',
      SUBTITLE:
        'Showing distribution of cohort members in different age brackets',
    },
    TOP_DIAGNOSIS: {
      TITLE: 'Top Diagnosis by ',
      SUBTITLE: 'Showing top diagnosis by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_PROVIDERS: {
      TITLE: 'Top Providers ',
      SUBTITLE: 'Showing top providers by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_PROCEDURES: {
      TITLE: 'Top Procedures ',
      SUBTITLE: 'Showing top procedures by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    PLAN: ' plan',
    emptyData: 'The chosen measure does not have any non-compliant members',
  },
};
